import { CheckImageIsFile, CheckDataIfExit } from "src/helper/publicFunction";
import { setLoading } from "src/store/customizer/CustomizerSlice";
import { GetFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";
import { PostFunction } from "src/utils/axios_connection";
import { toast } from "react-toastify";

export const GetSubServices =
  ({ callback, rowsPerPage, page }) =>
  async (dispatch, getState) => {
    try {
      let link = UrlApi.sub_services.get + `?page=${page}&limit=${rowsPerPage}`;
      const response = await GetFunction({
        data: {},
        Route: link,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
        usersRoute: true,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const DeleteSubService =
  ({ mediaListId, callback }) =>
  async (dispatch, getState) => {
    try {
      let link = UrlApi.sub_services.delete;
      const response = await GetFunction({
        data: {},
        Route: link + `/${mediaListId}`,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
        usersRoute: true,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const ManageSubServices =
  ({ callback, values, editMode }) =>
  async (dispatch, getState) => {
    console.log({ values_ManageSubServices: values });

    try {
      const { demo_video, image } = values;
      if (demo_video?.name) {
        const file_type = demo_video?.name?.split(".").pop();
        if (
          file_type === "mp4" ||
          file_type === "mov" ||
          file_type === "webm" ||
          file_type === "avi" ||
          file_type === "wmv" ||
          file_type === "flv"
        ) {
          values.demo_video = demo_video;
        } else {
          return toast.error("Please select a valid video");
        }
      }
      if (image?.name) {
        const file_type = image?.name?.split(".").pop();
        if (
          file_type === "jpg" ||
          file_type === "jpeg" ||
          file_type === "png" ||
          file_type === "gif"
        ) {
          values.image = image;
        } else {
          return toast.error("Please select a valid image");
        }
      }
      dispatch(setLoading(true));
      var bodyFormData = new FormData();
      let paramID = "";
      if (editMode) {
        paramID = values?.id;
      }
      if (CheckDataIfExit(values?.name)) {
        bodyFormData.append("name", values?.name);
      }
      if (CheckDataIfExit(values?.description_short)) {
        bodyFormData.append(
          "description_short",
          values?.description_short?.trim()
        );
      }
      if (CheckDataIfExit(values?.description_long)) {
        bodyFormData.append(
          "description_long",
          values?.description_long?.trim()
        );
      }
      if (CheckDataIfExit(values?.main_service_id)) {
        bodyFormData.append("main_service_id", values?.main_service_id);
      }
      if (CheckDataIfExit(values?.is_applicable_form)) {
        bodyFormData.append("is_applicable_form", values?.is_applicable_form);
      }

      if (
        values?.image &&
        values?.image != null &&
        values?.image != undefined &&
        CheckImageIsFile({ data: values?.image, IsBoolean: true })
      ) {
        bodyFormData.append("image", values?.image);
      } else if (editMode && !values?.image) {
        bodyFormData.append("image", "");
      }

      if (
        values?.demo_video &&
        values?.demo_video != null &&
        values?.demo_video != undefined &&
        CheckImageIsFile({ data: values?.demo_video, IsBoolean: true })
      ) {
        bodyFormData.append("demo_video", values?.demo_video);
      } else if (editMode && !values?.demo_video) {
        bodyFormData.append("demo_video", "");
      }

      const response = await PostFunction({
        data: bodyFormData,
        Route: editMode
          ? `${UrlApi.sub_services.edit}/${paramID}`
          : UrlApi.sub_services.add,
        showalert: true,
        state: getState,
        isMultipart: true,
        dispatch: dispatch,
        usersRoute: true,
      });
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      console.error({ err_ManageSubServices: err });
      dispatch(setLoading(false));
      callback(false);
    }
  };

export const EditSubServices =
  ({ callback, allData, id, nameFailed, dataFailed }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      let data;
      if (allData) {
        data = allData;
      } else {
        data = {
          [nameFailed]: dataFailed,
        };
      }
      // the edit route is multipart, so the payload has to be a real FormData
      // otherwise axios sends an object that multer parses as an empty body
      var bodyFormData = new FormData();
      Object.keys(data).forEach((key) => {
        if (CheckDataIfExit(data[key])) {
          bodyFormData.append(key, data[key]);
        }
      });
      const response = await PostFunction({
        data: bodyFormData,
        Route: UrlApi.sub_services.edit + `/${id}`,
        showalert: true,
        state: getState,
        isMultipart: true,
        dispatch: dispatch,
        usersRoute: true,
      });
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };
